"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferredLevelSelector = exports.HighestBitrateSelector = void 0;
function extractBitrate(encodings) {
    var _a, _b;
    return ((_a = encodings.audioKbps) !== null && _a !== void 0 ? _a : 0) + ((_b = encodings.videoKbps) !== null && _b !== void 0 ? _b : 0);
}
function bestBitrate(prev, curr) {
    return extractBitrate(prev) > extractBitrate(curr) ? prev : curr;
}
class HighestBitrateSelector {
    select(encodings) {
        return encodings.reduce(bestBitrate);
    }
}
exports.HighestBitrateSelector = HighestBitrateSelector;
class PreferredLevelSelector {
    constructor(preferredLevel) {
        this.preferredLevel = preferredLevel;
        this.preferredBitrate = 0;
    }
    select(encodings) {
        if (this.preferredLevel === null) {
            return encodings.reduce(bestBitrate);
        }
        let selected = null;
        for (const encoding of encodings) {
            const bitrate = extractBitrate(encoding);
            if (bitrate <= this.preferredBitrate) {
                selected = encoding;
            }
        }
        if (selected == null) {
            selected = encodings[0];
        }
        return selected;
    }
}
exports.PreferredLevelSelector = PreferredLevelSelector;
//# sourceMappingURL=encoding-selectors.js.map